export default __webpack_public_path__ + "static/media/Abhilash_Reddy_Sandi_Resume.fb26aae3.pdf";